export enum ESubscriptionType {

    Plateform = "subscription_plateform",
}
  